import { navigate } from 'raviger'

import { rememberReturnPath } from './return_path'

export class ApiError extends Error {
  constructor(status, body) {
    super(body?.message || `http_${status}`)
    this.status = status
    this.code = body?.message || `http_${status}`
    this.body = body
  }
}

async function request(method, path, body) {
  const options = {
    method,
    credentials: 'same-origin',
    headers: {}
  }
  if (body !== undefined) {
    options.headers['Content-Type'] = 'application/json'
    options.body = JSON.stringify(body)
  }

  const res = await fetch(path, options)
  let json = null
  try {
    json = await res.json()
  } catch {
    json = null
  }

  if (res.status === 401) {
    rememberReturnPath(location.pathname)
    navigate('/login')
    throw new ApiError(401, json)
  }
  if (!res.ok)
    throw new ApiError(res.status, json)

  return json
}

const api = {
  get: (path) => request('GET', path),
  post: (path, body = {}) => request('POST', path, body)
}

export default api
